function Footer() {
  return (
    <footer className="footer">
      <p>&copy; {new Date().getFullYear()} Anna Shishkina. All rights reserved.</p>
      <p>
        <a href="https://www.instagram.com/from_thepinewoods" target="_blank" rel="noopener noreferrer">Instagram</a>
        &nbsp;∙&nbsp;
        <a href="https://substack.com/@thepinewoods" target="_blank" rel="noopener noreferrer">Substack</a>
        &nbsp;∙&nbsp;
        <a href="https://www.etsy.com/shop/ThePineWoodsStore" target="_blank" rel="noopener noreferrer">Etsy</a>
      </p>
    </footer>
  );
}

export default Footer;
